import localstorage from './localstorage'

const storage = localstorage.build()

export {
    storage,
}